import React, {lazy, Suspense, useEffect, useState} from "react";
import {BrowserRouter as Router, Redirect, Route, Switch, matchPath} from "react-router-dom";
import routes from './routing/routes';
import PrivateRouter from './routing/PrivateRouter'
import {connect} from "react-redux";
import Login from "./pages/auth/Login";
import PublicRoute from "./routing/PublicRoute";
import SplashScreen from "./modules/main/splash-screen/SplashScreen";
import {getUser} from "./api/auth/Auth";
import {responseValidate} from "./utils/functions";
import Store from "./store";
import {setStore,setGamesData,setStateCalculation,setFeaturesForStore,setDarkMode} from "./store/reducers/App";
import {setShowThemeModal, setResetPasswordStatus} from "./store/reducers/Auth";
import {saveUserObject} from "./store/reducers/Auth";
import './styles/App.scss'
import GlobalToast from "./modules/Other/GlobalToast";
import {setStoreSettings} from "./store/reducers/StoreSettings";
import {AnimatePresence} from "framer-motion";
import ForgotPassword from "./pages/auth/forgot-password";
import ResetPassword from "./pages/auth/reset-password";
import {isSubscribed} from "./utils/subscription";
import {app_timezone} from "./settings";
import dayjs from './utils/dayjs';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import Request from "./utils/Request";
import {api_version} from "./settings";
import ShortLinkRedirect from "./routing/ShortLinkRedirect";
import { setCookie,getCookie } from "./utils/utmCookies";
import {Button, Modal, Form} from "react-bootstrap";
import { change_password } from "./api/auth/Auth";
import { PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE } from "./utils/validation";

import { Helmet } from "react-helmet";

let mainModule;
const loadMain = () => {
    if (!mainModule) {
        mainModule = import('./modules/main/Main').catch(error => {
            mainModule = undefined;
            throw error;
        });
    }
    return mainModule;
};
const Main = lazy(loadMain);
const Register = lazy(() => import('./pages/auth/register'));
const Print = lazy(() => import('./pages/daily_report/Print'));
const Refer = lazy(() => import('./pages/refer/Refer'));
const SubscriptionPage = lazy(() => import('./pages/auth/SubscriptionPage'));

function App({isLoggedIn, store, resetPasswordStatus }) {


    const [loading, setLoading] = useState(true);
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const utm = {
            utm_source: params.get("utm_source"),
            utm_medium: params.get("utm_medium"),
            utm_campaign: params.get("utm_campaign"),
        };

        const savedSource = getCookie("hisably_utm_campaign");
        if (!savedSource) {
            Object.entries(utm).forEach(([key, value]) => {
                if (value) {
                    setCookie(`hisably_${key}`, value, 60);
                }
            });  
        }

    }, []);

    // press tab skip all disabled and redonly field 
    useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.key === 'Tab') {
            const focusableElements = [...document.querySelectorAll('input:not([disabled]):not([readonly]):not([hidden])')];
            const currentIndex = focusableElements.indexOf(document.activeElement);
            if (currentIndex !== -1) {
              const nextIndex = (currentIndex + (e.shiftKey ? -1 : 1) + focusableElements.length) % focusableElements.length;
              focusableElements[nextIndex].focus();
              e.preventDefault();
            }
          }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    dayjs.tz.setDefault(app_timezone);

    useEffect(() => {
        // Fetch the layout and current page while the server checks the session.
        // This only downloads code; protected pages still wait for getUser().
        const pathname = window.location.pathname;
        const pages = routes.flatMap(route => route.child
            ? route.child.map(child => ({...child, path: route.path + child.path}))
            : [route]);
        const page = pages.find(route => matchPath(pathname, {path: route.path, exact: true}));
        if (page) {
            const codeStarted = performance.now();
            Promise.all([loadMain(), page.component.preload?.()]).then(() => {
                if (process.env.NODE_ENV === 'development') {
                    console.info(`[startup] Page code ready in ${Math.round(performance.now() - codeStarted)} ms`);
                }
            }).catch(() => {
                // Let the normal lazy render retry a failed preload.
            });
        }
        const sessionStarted = performance.now();
        getUser().then(responseValidate).then(result => {
            if (result.status) {
                if (result.data.stores !== null && result.data.stores.length > 0) {

                    const stores_data = result.data.stores;

                    /* const stored_item = localStorage.getItem("location"); */
                    const stored_item = result.data.store_id;

                    if (stores_data.length > 1 || stored_item) {
                        let matched_key = 0;
                        stores_data.map((value, key) => {
                            if (stored_item == value?.id)
                                matched_key = key;
                        });

                        Store.dispatch(setStoreSettings(result.data.stores[matched_key].settings))
                        Store.dispatch(setStore(result.data.stores[matched_key]))
                        Store.dispatch(saveUserObject(result.data, true));
                        Store.dispatch(setStateCalculation(result.data.state_calculations))
                        Store.dispatch(setGamesData(result.data.games))
                        Store.dispatch(setShowThemeModal(result?.data?.has_seen_theme_modal));
                        Store.dispatch(setResetPasswordStatus(result?.data?.is_password_reset));
                        // Apply dark mode theme
                        if (result.data.dark_mode) {
                            Store.dispatch(setDarkMode(true));
                            document.body.classList.add('dark-mode');
                        } else {
                            Store.dispatch(setDarkMode(false));
                            document.body.classList.remove('dark-mode');
                        }
                    } else {
                        Store.dispatch(setStoreSettings(result.data.stores[0].settings))
                        Store.dispatch(setStore(result.data.stores[0]))
                        Store.dispatch(saveUserObject(result.data, true));

                        // Apply dark mode theme
                        if (result.data.dark_mode) {
                            Store.dispatch(setDarkMode(true));
                            document.body.classList.add('dark-mode');
                        } else {
                            Store.dispatch(setDarkMode(false));
                            document.body.classList.remove('dark-mode');
                        }
                    }
                    if ((!result?.data?.roles?.includes("Super Admin") && result?.data?.login_type === 'auto') || (!result?.data?.roles?.includes("Super Admin") && result?.data?.login_type === 'manual')) {
                        Request.get(`${api_version}/lottery/new-features`)
                            .then(response => {
                            if (response.status && response.data) {
                                Store.dispatch(setFeaturesForStore(response.data.data));
                            }
                            })
                            .catch(error => {
                            console.error("API error:", error);
                            });
                    }
                } else {
                    Store.dispatch(saveUserObject(result.data, false));

                    // Apply dark mode theme
                    if (result.data.dark_mode) {
                        Store.dispatch(setDarkMode(true));
                        document.body.classList.add('dark-mode');
                    } else {
                        Store.dispatch(setDarkMode(false));
                        document.body.classList.remove('dark-mode');
                    }
                }
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        }).finally(() => {
            if (process.env.NODE_ENV === 'development') {
                console.info(`[startup] Session check completed in ${Math.round(performance.now() - sessionStarted)} ms`);
            }
        })

    }, [])

    useEffect(() => {
        if (resetPasswordStatus === 1) {
            setShowResetPasswordModal(true);
        }
    }, [resetPasswordStatus]);

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (!newPassword || !confirmPassword) {
            setError("Both fields are required");
            return;
        }

        if (!PASSWORD_REGEX.test(newPassword)) {
            setError(PASSWORD_VALIDATION_MESSAGE);
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("New Password and Confirm Password do not match. Please try again.");
            return;
        }

        try {
            setError('');

            const response = await change_password(
                true,              
                null,
                newPassword,
                confirmPassword
            );

            if (response.status) {
                setShowResetPasswordModal(false);
                setNewPassword('');
                setConfirmPassword('');
                Store.dispatch(setResetPasswordStatus(0));
            } else {
                setError(response.message);
            }

        } catch (err) {
            setError("Something went wrong");
        }
    };
    if (loading)
        return <SplashScreen/>

    return (
        <>
            <Helmet>
                <title>Hisably</title>
                <meta name="description" content="Lottery Management Software for C Stores" />
                <meta property="og:title" content="Hisably" />
                <meta property="og:description" content="Lottery Management Software for C Stores" />
                <meta property="og:image" content="https://hisably.com/wp-content/themes/hisably/img/favicon.ico" />
            </Helmet>
            <Suspense fallback={<SplashScreen />}>
            <Router>
                <AnimatePresence>
                    <Switch>
                        <Route path="/r/:code" component={ShortLinkRedirect} />
                        <PublicRoute path='/login' component={Login}/>
                        <PublicRoute path='/register' component={Register}/>
                        <PublicRoute path='/forgot-password' component={ForgotPassword}/>
                        <PublicRoute path='/reset-password' component={ResetPassword}/>
                        {
                            isLoggedIn && 
                            <>
                                {
                                window.location.pathname == '/daily_report/print' ?
                                    <>
                                        {
                                            !isSubscribed(store) && 
                                            <>
                                                <Route path='/' component={SubscriptionPage}/>
                                            </>
                                        }
                                        <Route exact strict path='/daily_report/print' component={Print}/>
                                        <PrivateRouter/>
                                        <GlobalToast/>
                                    </>
                                :
                                <Main>
                                    {
                                        !isSubscribed(store) && 
                                        <>
                                            <Route path='/' component={SubscriptionPage}/>
                                        </>
                                    }
                                    <Route path='/refer' component={Refer}/>
                                    <PrivateRouter/>
                                    <GlobalToast/>
                                    
                                    <TawkMessengerReact
                                        propertyId="5c40ce11ab5284048d0d6d36"
                                        widgetId="default"/>
                                </Main>
                            }
                        </>
                    }
                {
                    !isLoggedIn &&
                    <Route render={props => <Redirect to={{pathname: "/login", from: props.location}}/>}/>
                }
            </Switch>
        </AnimatePresence>
    </Router>
            </Suspense>

    <Modal
            show={showResetPasswordModal}
            centered
            backdrop="static"
            keyboard={false}
            onHide={() => {
            if (!newPassword || !confirmPassword) return;
                setShowResetPasswordModal(false);
            }}
        >
            <Modal.Header>
                <Modal.Title>Set New Password</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form onSubmit={handleResetPassword}>
                    
                    <Form.Group>
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mt-2">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </Form.Group>

                    {error && (
                        <div style={{ color: "red", marginTop: 10 }}>
                            {error}
                        </div>
                    )}

                    <Button className="mt-3" type="submit">
                        Confirm
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>

    </>)
}

const mapStateToProps = (state) => ({
    isLoggedIn: state.Auth.isLoggedIn,
    resetPasswordStatus: state.Auth.resetPasswordStatus,
    store: state.App.store,
})

export default connect(mapStateToProps)(App)
